/** 官网占 `/` 之后，控制台概览不再是 index。 */
export const CONSOLE_HOME = '/today';

/**
 * 登录成功后的去处。
 * 从官网或登录页本身进来时进概览，不要把人再送回营销首页。
 */
export function afterLoginPath(from?: string | null): string {
  if (!from || from === '/' || from === '/login') return CONSOLE_HOME;
  return from;
}
